import React from 'react'
import { subscribe } from 'react-contextual'
import { PortfoliosProvider } from '../../../../providers'
import { SearchFilter, ListingTemplate } from '../../..'
import { TableProvider } from '../../../organisms/Table'
import PortfolioTable from '../PortfolioTable/PortfolioTable'
import { $TSFixMe } from 'types/ts-migrate'

interface PortfoliosProps {
  location?: $TSFixMe
  redirect?: (...args: any[]) => any
}

function Portfolios({
  // PortfoliosProvider
  location,

  redirect,
}: PortfoliosProps): React.ReactElement {
  return (
    <TableProvider>
      <ListingTemplate
        loading={false}
        Header={<SearchFilter location={location} redirect={redirect} filters={[]} />}
        Body={<PortfolioTable />}
      />
    </TableProvider>
  )
}

export default subscribe([PortfoliosProvider], ({ location, redirect }: PortfoliosProps) => ({
  location,
  redirect,
}))(Portfolios)
